import { notificationApi } from "../config/notification";

export const getNoti = (id) => {
    return notificationApi.getNoti(id).then(response => response);
};

export const read = (id) => {
    return notificationApi.read(id).then(response => response);
};
